import * as React from "react";

function IcProductAirportTransportFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductAirportTransportFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 15L19.5 16.5L19 18V16C19 15.4477 18.5523 15 18 15H19ZM9.25 9H8.20869C6.33389 9 4.71064 10.3021 4.30394 12.1323L4 13.5L3.07927 13.1931C2.74689 13.0823 2.38362 13.2328 2.22693 13.5461C2.09141 13.8172 2.14453 14.1445 2.35881 14.3588L3 15C2.44772 15 2 15.4477 2 16V18.382C2 19.0672 2.38713 19.6936 3 20V21C3 21.8284 3.67157 22.5 4.5 22.5C5.32843 22.5 6 21.8284 6 21V20H15V21C15 21.8284 15.6716 22.5 16.5 22.5C17.3284 22.5 18 21.8284 18 21V20C18.6129 19.6936 19 19.0672 19 18.382V21.5C19 22.0523 19.4477 22.5 20 22.5C20.5523 22.5 21 22.0523 21 21.5V18L20.5 16.5L21 15C22.1046 15 23 14.1046 23 13V3C23 1.89543 22.1046 1 21 1H9C7.89543 1 7 1.89543 7 3V8H9.5L9 6H10L11 7H14L13 2H14L17 7H21C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H17L15.0006 12.3323C15.0474 12.4432 15.088 12.5578 15.1217 12.6758L15.3179 13.3626C15.4092 13.682 15.1693 14 14.8371 14H14H13H6.16286C5.83068 14 5.59084 13.682 5.6821 13.3626L5.87833 12.6758C6.24631 11.3879 7.42346 10.5 8.7629 10.5H12.2371C12.7354 10.5 13.2112 10.6229 13.6313 10.8435L14 9H11L10 10H9L9.25 9ZM5.5 18H7.5C8.05228 18 8.5 17.5523 8.5 17C8.5 16.4477 8.05228 16 7.5 16H5.5C4.94772 16 4.5 16.4477 4.5 17C4.5 17.5523 4.94772 18 5.5 18ZM15.5 18H13.5C12.9477 18 12.5 17.5523 12.5 17C12.5 16.4477 12.9477 16 13.5 16H15.5C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18Z"
        fill="#6DD3CE"
      />
    </svg>
  );
}

export default IcProductAirportTransportFill;
